import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';

class Footer extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Footer area start */}
                <div className="text-center footer">
                    <p>&copy; 2021 | All Rights Reserved.</p>
                </div>
                {/* Footer area end */}
            </div>
        )
    }
};

export default Footer;